import React from 'react'
import { FormControl, Button } from 'react-bootstrap'
import { ExportCSV } from '../_reusedcomponents/ExportCSVView'

/**
 * Generic view for transaction headers, specifying buttons, searchbar and excel export
 * Used for React Composition
 * @param {any} children props to be displayed; normally one or more buttons used by parent container
 * @param {string} title view title header
 * @param {any} filteredTransactions transactions to be exported to csv with filtering already applied
 * @param {string} fileName passes the fileName for the csv to be downloaded
 * @param {any} handleSearchInput handles the user input in the searchbar
 * @param {any} setFilterbar hook to show or hide the filter menu
 * @param {any} getCsvData function to parse data into json format
 */
const MainComponentHeaderView = ({ children, title, filteredElements, fileName, handleSearchInput, setFilterbar, getCsvData, showExportButton = true, filterArticles, toggleFilterArticles }) => {
    return (
        <>
            <h1 className="title">{title}</h1>

            {children}
            <div className="inline">
                <FormControl className="globalSearch" as="input" placeholder={window.i18n('search')} onChange={handleSearchInput}></FormControl>
                {!showExportButton ? <Button variant="light" className="filter-button form-control" onClick={toggleFilterArticles}>{filterArticles ? window.i18n('filterArticles') : window.i18n('filterTransactions') }</Button> : <></>}
                <Button variant="light" className="form filter-button form-control" onClick={setFilterbar}>&#8711; Filter</Button>
                {showExportButton ? <ExportCSV csvData={getCsvData(filteredElements)} fileName={fileName} /> : <></>}
                <div className="clear"></div>
            </div>
        </>
    )
}

export { MainComponentHeaderView }